import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import TwoFactorSetup from "@/components/TwoFactorSetup";
import { twoFAResetStart, twoFAResetConfirm, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const ResetTwoFA = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { login } = useAuth();
  const [setup, setSetup] = useState(null);
  const [invalid, setInvalid] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) { setInvalid("This link is missing its token."); return; }
    twoFAResetStart(token).then(setSetup).catch((e) => setInvalid(apiError(e)));
  }, [token]);

  const confirm = async (code) => {
    setError("");
    setLoading(true);
    try {
      const res = await twoFAResetConfirm(token, code);
      login(res.token, res.user);
      navigate("/", { replace: true });
    } catch (e) {
      setError(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (invalid) {
    return (
      <AuthShell title="Link expired" subtitle={invalid}>
        <Link to="/login" className="block text-center text-sm text-[#002FA7] hover:underline" data-testid="reset2fa-invalid-back">Back to sign in</Link>
      </AuthShell>
    );
  }
  if (!setup) {
    return <AuthShell title="New authenticator" subtitle="Preparing your QR code…"><Loader2 className="mx-auto animate-spin text-slate-400" /></AuthShell>;
  }
  return (
    <AuthShell title="New authenticator" subtitle={`Scan this QR code for ${setup.email}, then enter the 6-digit code.`}>
      <TwoFactorSetup qrPng={setup.qr_png} otpauthUri={setup.otpauth_uri} onSubmit={confirm} loading={loading} error={error} />
    </AuthShell>
  );
};

export default ResetTwoFA;
